import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';

type News = {
  id: number;
  withAlert: boolean;
  subject: string;
  expiredAt: number;
};

export type NewsState = {
  unread: News[];
};
const defaultState: NewsState = {
  unread: [],
};

type NewsReducers = {
  fetchUnreadNewsItemsSuccessAction: CaseReducer<
    NewsState,
    PayloadAction<News[]>
  >;
};

type NewsSelectors = {
  getUnreadSelector: (state: NewsState) => News[];
};

const news = createSlice<NewsState, NewsReducers, 'news', NewsSelectors>({
  name: 'news',
  initialState: defaultState,
  reducers: {
    fetchUnreadNewsItemsSuccessAction: (state, { payload }) => ({
      ...state,
      unread: payload,
    }),
  },
  selectors: {
    getUnreadSelector: (news) => news.unread || [],
  },
});

export const { fetchUnreadNewsItemsSuccessAction } = news.actions;
export const { getUnreadSelector } = news.selectors;

export default news.reducer;
